var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{attrs:{"headers":_vm.headers,"routes":_vm.routes,"url":_vm.url,"row-actions":_vm.rowActions,"top-actions":_vm.topActions,"sort-by":"name","title":"Resources"},scopedSlots:_vm._u([{key:"item.isHidden",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.isHidden ? _vm.$t('Hidden') : '')+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }